module.exports = __webpack_public_path__ + "img/ALSi6-Monitor.ced3cea3.png";